import { render, staticRenderFns } from "./frack.vue?vue&type=template&id=2a1ab495&scoped=true"
import script from "./frack.vue?vue&type=script&lang=js"
export * from "./frack.vue?vue&type=script&lang=js"
import style0 from "./frack.vue?vue&type=style&index=0&id=2a1ab495&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a1ab495",
  null
  
)

export default component.exports